<template>
  <v-list-item dense class="rounded elevation-4 mt-2">
    <v-list-item-avatar color="primary">
      <v-icon dark> mdi-account </v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <!-- name and address number -->
      <v-list-item-title> {{ SessionData.member.name }}</v-list-item-title>
      <v-list-item-subtitle v-if="currentBreakpoint">
        {{ $t('common.label_adressNumber') }} {{ SessionData.member.addressNumber }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-row no-gutters>
        <v-tooltip top :color="$vuetify.theme.dark ? 'yellow darken-3' : 'blue darken-3'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" :color="$vuetify.theme.dark ? 'yellow darken-3' : 'blue darken-3'" class="mr-4" @click="toggleDarkmode()">
              <v-icon v-if="$vuetify.theme.dark" color="white"> mdi-weather-sunny </v-icon>
              <v-icon v-else color="white"> mdi-weather-night </v-icon>
            </v-btn>
          </template>
          <span v-if="$vuetify.theme.dark" v-html="$t('common.label_displayModeChangeLight')" />
          <span v-else v-html="$t('common.label_displayModeChangeDark')" />
        </v-tooltip>
        <v-tooltip top color="error">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="red" v-bind="attrs" v-on="on" @click="handleLogoutClick()" :disabled="loading">
              <v-icon color="white"> mdi-logout </v-icon>
            </v-btn>
          </template>
          <span> {{ $t('common.label_logout_user', [SessionData.member.name]) }} </span>
        </v-tooltip>
      </v-row>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
// vuex
import { mapGetters } from 'vuex';
import { GET_SESSIONDATA } from '@/store/storeMutator';

// mixins
import HelpersMixin from '@/mixins/helpers.js';
import ResponsiveMixin from '@/mixins/responsive.js';

export default {
  emits: ['onLogoutClick'],

  props: {
    loading: Boolean,
  },

  mixins: [HelpersMixin, ResponsiveMixin],

  methods: {
    handleLogoutClick() {
      this.$emit('onLogoutClick');
    },

    toggleDarkmode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;

      if (this.$vuetify.theme.dark) {
        this.setCookie(this.COOKIEKEY_DISPLAYMODE, this.COOKIEVAL_DISPLAYMODE_DARK, 0, true);
      } else {
        this.setCookie(this.COOKIEKEY_DISPLAYMODE, this.COOKIEVAL_DISPLAYMODE_LIGHT, 0, true);
      }
    },
  },

  computed: {
    ...mapGetters({ SessionData: GET_SESSIONDATA }),
  },
};
</script>

<style scoped>
.v-list--two-line .v-list-item,
.v-list-item--two-line {
  min-height: 0px;
}
</style>